<template>

    <div class="chart-dog-step-3">

        <b-tabs v-model="currentSeriesTab">
            <b-tab v-for="(series, seriesIndex) in docData.chart.chartSeries">
                <template v-slot:title>
                    {{ series.title ? series.title : 'Series ' + (seriesIndex + 1) }}
                </template>
                <!-- TODO: active tab (docData.currentSeries) -->

                <b-card no-body>
                    <b-card-body>
                        <b-form-checkbox v-model="series.showTrendline">
                            Show Trendline
                        </b-form-checkbox>
                        <b-form-checkbox v-model="series.showMean">
                            Show Mean Value
                        </b-form-checkbox>
                        <b-form-checkbox v-model="series.showAimline">
                            Show Aimline
                        </b-form-checkbox>
                        <b-card no-body
                                v-if="series.showAimline">
                            <b-card-header>
                                Aimline Values
                            </b-card-header>
                            <b-card-body>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th></th>
                                        <th>Start Target</th>
                                        <th>End Target</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="phase in docData.chart.phases">
                                        <th>
                                            {{ phase.title }}
                                            <chart-dog-legend-label :series-shape="currentChartSeriesMarkerName"
                                                                    :series-color-code="currentChartSeriesColorCode"
                                                                    :phase-index="+phase.index">
                                            </chart-dog-legend-label>
                                        </th>
                                        <td v-for="ap in docData.chart.aimlinePoints"
                                            v-if="ap.chartSeries == docData.currentSeries && ap.chartPhase == phase.index">
                                            <b-form-input type="number"
                                                          placeholder="Value"
                                                          v-model="ap.value"/>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </b-card-body>
                        </b-card>
                    </b-card-body>
                </b-card>
            </b-tab>
        </b-tabs>


    </div>

</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import ChartDogMixin from "@/providers/ChartDogMixin"

    export default Vue.extend({
        name: "ChartDogStep3",
        mixins: [ToolMixin, ChartDogMixin],
    })

</script>


